import { Record } from "immutable";
import { HubspotFormSubmissionField } from "models/interfaces/hubspot-form-submission";

const defaultValues: HubspotFormSubmissionField = {
    name: "",
    value: "",
    objectTypeId: "",
};

export default class HubspotFormSubmissionFieldRecord
    extends Record(defaultValues)
    implements HubspotFormSubmissionField
{
    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: HubspotFormSubmissionField) {
        if (params == null) params = Object.assign({}, defaultValues);

        super(params);
    }

    // #endregion Constructor

    /**
     * Returns new object based on `this` and merges the partial values
     * @param  {Partial<HubspotFormSubmission>} values
     * @returns HubspotFormSubmission
     */
    public with(
        values: Partial<HubspotFormSubmissionField>
    ): HubspotFormSubmissionFieldRecord {
        return new HubspotFormSubmissionFieldRecord(
            Object.assign(
                this.toJS(),
                values
            ) as HubspotFormSubmissionFieldRecord
        );
    }
}
